'use strict';

namespace TR {
    class SelectOffice {

        lightbox: boolean = false;
        OfficeLocations;
        selectedOffice;

        constructor(
            private agentModeService,
            private $location: ng.ILocationService
        ) {
            this.lightbox = true;
            this.agentModeService.getAgentInformation().then(data => {
                this.OfficeLocations = data.OfficeLocations;
                this.selectedOffice = data.CurrentOfficeLocation;
                if (this.OfficeLocations.length === 1) {
                    this.setSelectedOffice(this.OfficeLocations[0].Id);
                }
            });
        }

        setSelectedOffice(office) {
            this.agentModeService.setOfficeLocation(office).then(() => {
                window.location.href = this.$location.absUrl().replace('selectoffice', '');
            });
        }

    }

    angular
    .module('TR')
    .controller('SelectOffice', SelectOffice);
}
